(() => {
  const root = document.querySelector('[data-lds-legacy-purchase]');
  if (!root || !window.LdsPurchasePanel) return;
  const form = root.querySelector('form.hdt-main-product-form');
  const stickyForm = root.querySelector('form.hdt-sticky-atc__form');
  if (!form) return;
  const inputs = [form.elements.namedItem('quantity'), stickyForm?.elements.namedItem('quantity')].filter(n => n instanceof HTMLInputElement);
  const source = document.getElementById(`LdsPurchaseRules-${root.dataset.productId}`);
  if (!source || !inputs.length) return;
  const records = JSON.parse(source.textContent);
  const rules = Object.fromEntries(Object.entries(records).map(([id, rule]) => [id, {...rule}]));
  // Initial markup may include the initial variant's inventory maximum.
  // Apply it only to that variant; later native events supply their own rules.
  const initialId = form.elements.namedItem('id')?.value;
  const initialMax = Math.min(...inputs.map(n => n.max ? Number(n.max) : Infinity));
  if (rules[initialId] && Number.isFinite(initialMax)) rules[initialId].max = Math.min(rules[initialId].max ?? Infinity, initialMax);
  const buttons = inputs.flatMap(n => [...n.closest('hdt-quantity-wrapp').querySelectorAll('button[name="minus"], button[name="plus"]')]);
  buttons.forEach(n => { n.dataset.qtyChange = n.name === 'plus' ? '1' : '-1'; });
  const money = cents => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents, root.dataset.moneyFormat) : new Intl.NumberFormat(undefined,{style:'currency', currency:root.dataset.currency || 'USD'}).format(cents / 100);
  const panel = window.LdsPurchasePanel.install(root, {form, formatMoney:money, quantityRules:rules, visibleInput:inputs, hiddenInput:[], quantityButtons:buttons, manageNativeQuantity:true, addButtons:form.querySelectorAll('button[name="add"]'), stickyAdd:stickyForm?.querySelectorAll('button[name="add"]') || [], stickyPrice:root.querySelectorAll('[data-lds-legacy-sticky-total]')});
  const sync = () => {
    const field = form.elements.namedItem('id');
    const id = field?.value, record = records[id];
    panel.render(record ? {id, price:record.price, available:record.available} : null, Boolean(record?.available && !field?.disabled));
  };
  const schedule = () => queueMicrotask(sync);
  root.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (variant?.quantity_rule && rules[String(variant.id)]) rules[String(variant.id)] = {...variant.quantity_rule};
    schedule();
  },true);
  form.addEventListener('change', schedule);
  stickyForm?.addEventListener('submit', () => panel.normalizeNow(),true);
  stickyForm?.querySelector('select[name="id"]')?.addEventListener('change', () => requestAnimationFrame(sync));
  inputs.forEach(n => n.addEventListener('change', schedule));
  // Variant picker updates the normal form before its variant:change event;
  // its live hidden ID remains authoritative for both synchronized forms.
  sync();
})();
